import { render, staticRenderFns } from "./DialogAddLawCollection.vue?vue&type=template&id=26764ad7&scoped=true"
import script from "./DialogAddLawCollection.vue?vue&type=script&lang=js"
export * from "./DialogAddLawCollection.vue?vue&type=script&lang=js"
import style0 from "./DialogAddLawCollection.vue?vue&type=style&index=0&id=26764ad7&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26764ad7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26764ad7')) {
      api.createRecord('26764ad7', component.options)
    } else {
      api.reload('26764ad7', component.options)
    }
    module.hot.accept("./DialogAddLawCollection.vue?vue&type=template&id=26764ad7&scoped=true", function () {
      api.rerender('26764ad7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DialogAddLawCollection.vue"
export default component.exports